var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuMobileQuickship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 3",
    y1: 1.25,
    x2: 24,
    y2: 1.25,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 4",
    y1: 7.90509,
    x2: 24,
    y2: 7.90509,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    y1: 14.5602,
    x2: 24,
    y2: 14.5602,
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuMobileQuickship);
export default __webpack_public_path__ + "static/media/icon-menu-mobile-quickship.80b29679adc08910e1196c32e966aac8.svg";
export { ForwardRef as ReactComponent };